
const unpackEndpoint = (endpoints: any) => {
    return endpoints[process.env.BRG_ENV as keyof typeof endpoints]
}

export const EndpointsServerIndex = {
    default: {
        tagsMnePw: unpackEndpoint({
            development: 'https://api.burgdev.ru/tags',
            staging: 'https://api.burgstg.ru/tags',
            production: 'https://api.mediiia.ru/tags',
        }),
        geograffee: unpackEndpoint({
            development: 'https://api.burgdev.ru/geograffee',
            staging: 'https://api.burgstg.ru/geograffee',
            production: 'https://api.mediiia.ru/geograffee',
        }),
        competitions: unpackEndpoint({
            development: 'https://api.burgdev.ru/competitions',
            staging: 'https://api.burgstg.ru/competitions',
            production: 'https://api.mediiia.ru/competitions',
        }),
    },
    ftblproduction: {
        tagsMnePw: unpackEndpoint({
            development: 'https://api.rprod.extall.ru/tags',
            staging: 'https://api.rprod.extall.ru/tags',
            production: 'https://api.rprod.extall.ru/tags',
        }),
        geograffee: unpackEndpoint({
            development: 'https://api.rprod.extall.ru/geograffee',
            staging: 'https://api.rprod.extall.ru/geograffee',
            production: 'https://api.rprod.extall.ru/geograffee',
        }),
        competitions: unpackEndpoint({
            development: 'https://api.rprod.extall.ru/competitions',
            staging: 'https://api.rprod.extall.ru/competitions',
            production: 'https://api.rprod.extall.ru/competitions',
        }),
    },
} as const;

export const EndpointsServer = EndpointsServerIndex[process.env.DEPLOY_ENV as keyof typeof EndpointsServerIndex]
    || EndpointsServerIndex.default;

const unpackEndpoint = (endpoints: any) => {
    return endpoints[process.env.BRG_ENV as keyof typeof endpoints]
}

export const EndpointsServerIndex = {
    default: {
        tagsMnePw: unpackEndpoint({
            development: 'https://api.burgdev.ru/tags',
            staging: 'https://api.burgstg.ru/tags',
            production: 'https://api.mediiia.ru/tags',
        }),
        geograffee: unpackEndpoint({
            development: 'https://api.burgdev.ru/geograffee',
            staging: 'https://api.burgstg.ru/geograffee',
            production: 'https://api.mediiia.ru/geograffee',
        }),
        competitions: unpackEndpoint({
            development: 'https://api.burgdev.ru/competitions',
            staging: 'https://api.burgstg.ru/competitions',
            production: 'https://api.mediiia.ru/competitions',
        }),
    },
    ftblproduction: {
        tagsMnePw: unpackEndpoint({
            development: 'https://api.rprod.extall.ru/tags',
            staging: 'https://api.rprod.extall.ru/tags',
            production: 'https://api.rprod.extall.ru/tags',
        }),
        geograffee: unpackEndpoint({
            development: 'https://api.rprod.extall.ru/geograffee',
            staging: 'https://api.rprod.extall.ru/geograffee',
            production: 'https://api.rprod.extall.ru/geograffee',
        }),
        competitions: unpackEndpoint({
            development: 'https://api.rprod.extall.ru/competitions',
            staging: 'https://api.rprod.extall.ru/competitions',
            production: 'https://api.rprod.extall.ru/competitions',
        }),
    },
} as const;

export const EndpointsServer = EndpointsServerIndex[process.env.DEPLOY_ENV as keyof typeof EndpointsServerIndex]
    || EndpointsServerIndex.default;
